// Paths the public service uses for its own internal endpoints. User-authored
// step routes starting with RESERVED_ROUTE_PREFIX are rejected at commit time
// so adding a new internal route here can never silently shadow someone's step.

const RESERVED_ROUTE_PREFIX = "/__3b/";

export const HTML_VIEWER_ROUTE = `/__3b/html-viewer`;

export function isReservedRoute(route: string): boolean {
  return (
    route === RESERVED_ROUTE_PREFIX || route.startsWith(RESERVED_ROUTE_PREFIX)
  );
}
